import { formInputTypes } from 'commons/constants';
import type { DropdownItem } from 'commons/types';
import type { FormStructureItem, FormStateObject } from './Form.types';

const { SELECT } = formInputTypes;

const getData = (
  existingData: string,
  value: any,
  useDefaultValue: boolean | null | undefined,
): any =>
  !useDefaultValue && (existingData || typeof existingData === 'number') ? existingData : value;

const getSelectValue = (options: DropdownItem[], data: any): any =>
  options.find((o) => o.value === data) || data;

const getValue = (data: any, type?: string, options: DropdownItem[] = []): any =>
  type === SELECT && typeof data === 'string' ? getSelectValue(options, data) : data;

const generateForm = (
  formStructure: FormStructureItem[],
  existingData: any = {},
): FormStateObject => {
  const form = {
    errors: {},
    isTouched: {},
  };
  formStructure.forEach((field) => {
    const { id, options, type, useDefaultValue, value = '' } = field;
    const data = getData(existingData[id], value, useDefaultValue);
    form[id] = getValue(data, type, options);
    form.errors[id] = {};
    form.isTouched[id] = Boolean(data);
  });
  return {
    form,
  };
};

export default generateForm;
